import React, { useEffect, useState } from "react";
import { Icon } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { Favorite, FavoriteBorder, Reply } from "@mui/icons-material";
import { get } from "services/post/PartnershipService";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import Comments from "components/comments/comments";
import SectionFotos from "components/fotos/SectionFotos";
import Contact from "components/contact/contact";
import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import Map from "components/maps/Map";
import placeholder from "images/placeholder-small.png";

const SocialPartners: React.FC = () => {
  const [mosaicImg, setMosaicImg] = useState(
    "https://images.unsplash.com/photo-1598880513655-d1c6d4b2dfbf?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  );
  const [isFavorite, setIsFavorite] = useState(false);
  const [data, setData]: any = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await get(id);
      setData(response.data);
      console.log("data", response);

      setLoading(false);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [className, setClassName] = useState("desktop-13-new");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setClassName("mobile-4-new");
      } else {
        setClassName("desktop-13-new");
      }
    };

    handleResize(); // Chama a função ao montar o componente
    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="w-full h-full">
      <div className="flex items-center w-full overflow-hidden justify-center mb-2">
        <div
          className="flex justify-center items-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-[40vw] sm:h-[27vw] bg-cover bg-center"
          style={{
            backgroundImage: `url(${
              urlBase +
              "/storage/images/posts/partnerships/banners/" +
              data?.banner_path
            })`,
          }}
        >
          <div
            className="flex bg-black bg-opacity-50 w-full h-full justify-between px-8 md:px-12 items-center"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="flex flex-col lg:items-start gap-y-2 sm:gap-y-6 md:gap-y-12">
              <button className="w-fit rounded-full bg-primary-900 text-white text-sm md:text-base px-2 md:px-4 py-1 md:py-2 hover:bg-primary-600">
                {data.category?.name ?? "-"}
              </button>
              <span className="font-semibold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-white">
                {data.name ?? "-"}
              </span>
            </div>

            <div className="h-full flex flex-col justify-center gap-y-2 sm:gap-y-6 items-end">
              <img
                alt="partner logo"
                className={`object-cover ${className} bg-primary-600 bg-opacity-60 rounded-lg md:rounded-3xl`}
                //style={{ width: "6rem", height: "4rem" }}
                src={
                  urlBase +
                  "/storage/images/posts/partnerships/logos/" +
                  data?.logo_path
                }
                onError={(e) => (e.currentTarget.src = placeholder)}
              />
              {/* <div className="bg-white bg-opacity-40 mt-5 rounded-full p-2 shadow-md hover:bg-opacity-70 cursor-pointer" onClick={() => { setIsFavorite(!isFavorite) }}>
                                <Icon
                                    className="text-white"
                                    component={isFavorite ? Favorite : FavoriteBorder}
                                    fontSize="large"
                                />
                            </div> */}
            </div>
          </div>
        </div>
      </div>

      <span className="desktop-margin w-full text-xs sm:text-base px-8 sm:px-0 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <Link to={"/"}>Home</Link> &gt; <Link to={"/social"}>Radar-Social</Link>{" "}
        &gt; <Link to={""}> {data.name ?? "-"}</Link>
      </span>

      <div className="desktop-margin flex flex-col lg:flex-row gap-x-8 px-8 sm:px-0 overflow-hidden w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[79rem] justify-between">
        
        <div className="w-full pt-10">
          {
            data?.benefits && (
              <div>
                <h1 className="font-bold text-xl sm:text-2xl">Como Contribuir</h1>
                <p className="leading-5 sm:leading-6 mt-5 text-xs sm:text-sm text-justify">
                  <div
                    className="text-justify"
                    dangerouslySetInnerHTML={{
                      __html: data.benefits ?? "-",
                    }}
                  ></div>
                </p>
                {/* <p className="leading-5 sm:leading-6 mt-3 text-xs sm:text-sm text-justify">Nunc lacus erat, porttitor at orci nec, facilisis commodo urna. Cras placerat lacinia lacus, eget ornare augue elementum at. Donec tincidunt ligula vitae vestibulum cursus. Integer ac venenatis velit. Quisque vitae ligula dolor. Suspendisse vestibulum, diam eget placerat rutrum, elit ex mattis justo, et egestas nulla lorem eget elit.</p> */}
              </div>
            )
          }

          <div>
            <h1 className="mt-10 font-bold text-xl sm:text-2xl">Detalhes</h1>
            <p className="leading-5 sm:leading-6 mt-5 text-xs sm:text-sm">
              <div
                className="text-justify"
                dangerouslySetInnerHTML={{
                  __html: data.description ?? "-",
                }}
              ></div>
            </p>
          </div>
          {
            data?.about_us && (
              <div className="">
                <h1 className="font-bold mt-10 text-xl sm:text-2xl">
                  Sobre a Empresa
                </h1>
                <p className="leading-5 sm:leading-6 mt-5 text-xs sm:text-sm text-justify">
                  <div
                    className="text-justify"
                    dangerouslySetInnerHTML={{
                      __html: data.about_us ?? "-",
                    }}
                  ></div>
                </p>
              </div>
            )
          }
                
          <div className="mt-16">
            {data.address?.address && data.address?.number && (
              <>
                <div>
                  <h1 className="font-bold mt-10 text-xl sm:text-2xl">
                    Localização
                  </h1>
                  {/* Aqui usamos o componente Map passando o endereço como prop */}
                  <Map address={`${data.address?.address}, ${data.address?.number}, ${data.address?.city}, ${data.address?.state}, ${data.address?.country}`} />
                </div>

                <p className="leading-5 sm:leading-6 mt-5 text-xs sm:text-sm text-justify">
                  {
                    `${data.address?.address} ${' '} ${data.address?.number} ${data.address?.complement ? ' ' + data.address?.complement : '' }, ${data.address?.city} ${' '} ${data.address?.state} ${' '} ${data.address?.country}`
                  }
                </p>
              </>         
            )}
          </div>

        </div>

        <div className="flex flex-1 flex-col h-fit items-center lg:items-end pt-0 md:pt-5 gap-y-10">
          <a href={data.url} target="_blank">
            <div style={{ top: "25px", position: "relative" }}>
              {data.url != null ? data.url : null}
            </div>
          </a>

          <div className="flex">
            {data.facebook != null ? (
              <a href={data.facebook} target="_blank" rel="noreferrer">
                <div className="p-0-25 click">
                  <FaFacebookSquare size={30} />
                </div>
              </a>
            ) : null}

            {data.instagram != null ? (
              <a href={data.instagram} target="_blank" rel="noreferrer">
                <div className="p-0-25 click">
                  <FaInstagramSquare size={30} />
                </div>
              </a>
            ) : null}

            {data.tiktok != null ? (
              <a href={data.tiktok} target="_blank" rel="noreferrer">
                <div className="p-0-25 click">
                  <FaTiktok size={30} />
                </div>
              </a>
            ) : null}

            {data.youtube != null ? (
              <a href={data.youtube} target="_blank" rel="noreferrer">
                <div className="p-0-25 click">
                  <FaYoutube size={30} />
                </div>
              </a>
            ) : null}

            {data.linkedin != null ? (
              <a href={data.linkedin} target="_blank" rel="noreferrer">
                <div className="p-0-25 click">
                  <FaLinkedin size={30} />
                </div>
              </a>
            ) : null}
          </div>

          {data.url_video && (
            <div className="w-full h-[12rem] sm:w-full sm:h-[20rem] md:w-[40rem] md:h-[23rem] lg:w-full lg:h-[16rem] border-[#F8F8F8] dark:border-[#1D2432] rounded-3xl overflow-hidden pl-0 md:pl-[30px]">
              <iframe
                className="border-[#F8F8F8] dark:border-[#1D2432] rounded-3xl border-8"
                width="100%"
                height="100%"
                src={data.url_video}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          )}

          <Contact post_type_id={5} post_id={data.post_id} />
        </div>
      </div>

      {data && data.attachments && data.attachments.length > 0 && (
        <div className="desktop-margin mb-10">
          <div className=" w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] px-3 md:px-0">
            <SectionFotos
              attachments={data.attachments}
              className="py-10 lg:py-28"
              url="/storage/images/posts/partnerships/attachments/"
            />
          </div>
        </div>
      )}

      {/* <div className=" w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] px-3 md:px-0">
                <SectionVideos className="py-16 lg:py-28" />
            </div> */}

      <div
        className="
                    flex flex-col lg:flex-row mb-20 justify-center gap-x-16 gap-y-20
                    w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] px-2
                "
      >
        {/* <Comments
                    dados={data}
                    tela="partnerships"
                    url="/posts/partnerships/comment"
                    get={fetchData}
                    classe="flex flex-col w-full"
                /> */}
        {/* <div className="flex justify-center items-center w-full lg:w-[400px] h-[16rem] lg:h-auto rounded-xl bg-gray-300">
                    <span className="text-2xl font-semibold">ADS</span>
                </div> */}
      </div>
    </div>
  );
};

export default SocialPartners;
